/**
 * Route for `advertiser-notifications`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserNotificationsPage } from "../features/advertiser-notifications/AdvertiserNotificationsPage";

export const advertiserNotificationsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-notifications",
	component: AdvertiserNotificationsPage,
});

export default advertiserNotificationsRoute;
